import $ from 'jquery';

var clock = function() {
	// Constants that won't change through the script
	const hourhand = document.querySelector(".hour");
	const minutehand = document.querySelector(".minute");
	const secondhand = document.querySelector(".second");
	const clock = document.querySelector(".clock-menu__hands");


	let day = $(clock).attr('data-day');
	let hr  = $(clock).attr('data-hour');
	let min = $(clock).attr('data-min');
	let sec = $(clock).attr('data-sec');

	day = parseInt(day);
	hr  = parseInt(hr);
	min = parseInt(min);
	sec = parseInt(sec);

	// Combined min + hours for easier buisness hours function
	let hrMin = hr + (min / 60);

	//var interval = setInterval(run_the_clock, 1000);

	//Run an ajax request to get the latest time
	let data = {
		action: 'get_current_time'
	};

	$.post(Ajax.url, data, function(res){
		res = $.parseJSON(res);
		
		console.log(res.day);
		day = parseInt(res.day);
		hr  = parseInt(res.hour);
		min = parseInt(res.minute);
		sec = parseInt(res.second);
		
		// Combined min + hours for easier buisness hours function
		hrMin = hr + (min / 60);

		var interval = setInterval(run_the_clock, 1000);
	});


//Get php data-attributes, js will offset this
function run_the_clock(){

  sec++;

  if (sec >= 60) {
    min++;
    sec = 1;
  }

  if (min >= 60) {
    hr++;
    min = 0;
  }

  if (hr >= 24) {
    hr = 0;
  }

  hrMin = hr + (min / 60);
  
  // console.table(['day ' + day, 'hour ' + hr, 'min ' + min, 'sec ' + sec]);

  let hrPosition = hr*360/12 + ((min * 360/60)/12) ;
  let minPosition = (min * 360/60) + (sec* 360/60)/60;
  let secPosition = sec * 360/60;

  //Then we need to apply these numbers as degrees in the inline styles for transform on each of the objects.
  hourhand.style.transform = "translate(-50%, -50%) rotate(" + hrPosition + "deg)";
  minutehand.style.transform = "translate(-50%, -50%) rotate(" + minPosition + "deg)";
  secondhand.style.transform = "translate(-50%, -50%) rotate(" + secPosition + "deg)";

  //If statements go here for availabilty
  if (9.5 <= hrMin && hrMin <=  17.5 && day <= 5) {
    $('.sidebar').removeClass('workshop-closed').addClass('workshop-open');
  } else {
    $('.sidebar').removeClass('workshop-open').addClass('workshop-closed');
  }
}

}

module.exports = clock;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/clock.js